import React, { useEffect } from 'react';

// Une photo en pleine lumière, au-dessus de tout (la barre de menu est en
// z-50). Flèches pour passer à la suivante, Échap ou un clic à côté pour
// fermer. Sert partout où une vignette mérite d'être vue en grand.
export default function Spotlight({ photos, index, onIndex, onClose }) {
  useEffect(() => {
    const k = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onIndex(Math.min(photos.length - 1, index + 1));
      if (e.key === 'ArrowLeft') onIndex(Math.max(0, index - 1));
    };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, [photos.length, index, onIndex, onClose]);

  const photo = photos[index];
  if (!photo) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/85 flex items-center justify-center p-4" onClick={onClose}>
      <button className="absolute top-4 right-4 text-white/80 hover:text-white text-2xl" aria-label="Fermer" onClick={onClose}>✕</button>
      {index > 0 && <button className="absolute left-3 text-white/80 hover:text-white text-3xl px-3" aria-label="Précédente" onClick={e => { e.stopPropagation(); onIndex(index - 1); }}>‹</button>}
      {/* La légende garde sa place sous la photo : l'image cède la hauteur, le texte long défile. */}
      <figure className="max-w-[92vw] flex flex-col items-center justify-center text-center" onClick={e => e.stopPropagation()}>
        <img src={photo.url} alt="" className="block max-w-[92vw] max-h-[72vh] w-auto h-auto object-contain rounded-lg" />
        <figcaption className="max-h-[18vh] overflow-y-auto text-white/80 text-sm mt-2 px-2">
          {photos.length > 1 ? `${index + 1} / ${photos.length}` : ''}{photo.legende ? `${photos.length > 1 ? ' · ' : ''}${photo.legende}` : ''}
        </figcaption>
      </figure>
      {index < photos.length - 1 && <button className="absolute right-3 text-white/80 hover:text-white text-3xl px-3" aria-label="Suivante" onClick={e => { e.stopPropagation(); onIndex(index + 1); }}>›</button>}
    </div>
  );
}
